module.exports = {
  CARDS_LIST: require('./cardsList'),
  INNER_FIELDS: require('./innerFields')
};
